import { Box, Typography } from "@mui/material";

const Home = () => {
  return (
    <Box sx={{ width: "100%", minHeight: "100vh" }}>
      {/* Responsive Image */}
      <Box
        component="img"
        src="/home1.jpg"
        alt="Background"
        sx={{
          width: "100%",
          height: { xs: "50vh", sm: "70vh", md: "90vh" }, // Responsive height
          objectFit: "cover",
          objectPosition: "center", // Centers the image focal point
          display: "block",
        }}
      />

      {/* Text Section */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#e6e4df",
          color: "black",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "90%", sm: "85%", md: "75%" }, // More responsive widths
            textAlign: "center",
            padding: { xs: "2rem", sm: "4rem", md: "6rem" }, // Responsive padding
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "1rem", sm: "1.2rem", md: "1.5rem" },
              lineHeight: { xs: 1.6, md: 1.8 }, // Improved line height for readability
              letterSpacing: "0.01em", // Slight letter spacing improves readability
            }}
          >
            Nicole Hahn Designs is a full-service boutique interior design firm
            that specializes in remodels, kitchen and bath design, and furnishings.
            We are passionate about using natural materials and creating timeless designs that will be loved for years to come.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;